import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
	Typography,
	IconButton
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import CakeIcon from '@material-ui/icons/Cake';

import useQueryParams from '../../hooks/useQueryParams';
import useMainContext from '../../hooks/useMainContext';

const actionWrapperWidth = 50;

const useStyles = makeStyles(theme => ({
	root: {
		minHeight: 50,
		display: 'flex',
		borderBottom: `1px solid #e0e0e0`
	},
	timeSection: {
		color: '#ffa500',
		display: 'flex',
		flexDirection: 'column',
		//width: '50%',
		minWidth: 100,
		marginTop: 5,
		marginBottom: 5,
		alignItems: 'center',
		justifyContent: 'center',
	},
	itemSection: {
		width: 'calc(100% - 100px)',
		paddingLeft: 13,
		paddingRight: 10,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		//flex: 1
	},
	title: {
		fontSize: 16,
	},
	contact: {
		fontSize: 10,
		color: '#929292'
	},
	detailWrapper: {
		width: `calc(100% - ${actionWrapperWidth}px)`,
	},
	actionWrapper: {
		width: actionWrapperWidth,
	}
}));

function BirthdateItem(props) {
	const classes = useStyles();
	const { 
		birthdateID,
		name,
		contact,
	} = props.details;

	// eslint-disable-next-line
	const [queryParams, setQueryParams] = useQueryParams();
	const { handleChange: handleMainContextChange } = useMainContext();

	const handleClick = () => {
		setQueryParams({ 'update-birthdate': birthdateID });
		handleMainContextChange({
			birthdateDetailUpdate: props.details,
		});
	};

	return (
		<div className={classes.root}>
			<div className={classes.timeSection}>
				<CakeIcon />
			</div>
			<div className={classes.itemSection}>
				<div className={classes.detailWrapper}>
					<Typography className={classes.name} noWrap>
						{name}
					</Typography>
					<div className={classes.contact}>
						{contact}
					</div>
				</div>
				<div className={classes.actionWrapper}>
					<IconButton onClick={handleClick}>
						<MoreVertIcon />
					</IconButton>
				</div>
			</div>
		</div>
	);
}

export default BirthdateItem;
